import { $authHost } from 'app/configs/axiosConfig';
import { FiltersFormValues } from 'src/app/admin/components/FiltersForm';

interface GetAffiliateLeadsParams {
  page: number;
  limit: number;
  filters?: FiltersFormValues;
  orderBy?: any;
}

export const getAffiliateLeads = async ({
  page,
  limit,
  filters,
  orderBy,
}: GetAffiliateLeadsParams) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  if (filters) {
    filters.filters.forEach((filterGroup) => {
      filterGroup.rules.forEach((rule) => {
        if (rule.value) {
          params.append(rule.field, String(rule.value));
        }
      });
    });
  }

  if (orderBy) {
    Object.keys(orderBy).forEach((key) => {
      params.append('orderBy', `${key}:${orderBy[key]}`);
    });
  }

  const response = await $authHost.get(`/affiliate-lead?${params.toString()}`);
  return response.data;
};

export const getAffiliateLeadsPost = async ({
  page,
  limit,
  filters,
  orderBy,
}: GetAffiliateLeadsParams) => {
  let where = {};
  if (filters) {
    where = {
      AND: filters.filters.flatMap((filter) =>
        filter.rules.map((rule) => ({ [String(rule.field)]: { [String(rule.mode)]: rule.value } })),
      ),
    };
  }

  const requestBody = {
    skip: (page - 1) * limit,
    take: limit,
    orderBy: orderBy,
    where: where,
  };

  const response = await $authHost.post(`/affiliate-lead/filter`, requestBody);
  return response.data;
};

export const deleteAffiliateLead = async (id: number) => {
  const response = await $authHost.delete(`/affiliate-lead/${id}`);
  return { success: true, data: response.data };
};

export const updateAffiliateLead = async (id: number, data: any) => {
  const response = await $authHost.put(`/affiliate-lead/${id}`, data);
  return { success: true, data: response.data };
};

export const checkAffiliateLeadsStatus = async () => {
  const response = await $authHost.post('/affiliate-lead/check-marked-for-upload');
  return response.data;
};
